<template>
  <div class="tournaments-selection" data-qe-id="tournaments-selection-tab-bar">
    <div
      v-for="id in tournamentsSelections"
      @click="emit('action', id.tournamentId)"
      :key="id.tournamentId"
      class="t-item"
      :class="selectedTId === id.tournamentId ? 'active' : ''"
      :data-qe-id="`tournaments-selection-tab--${id.tournamentId}`"
    >
      {{ id.name }}
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ tournamentsSelections: Array<TournamentsSelections>; selectedTId: string }>()
const emit = defineEmits(['action'])
</script>

<script lang="ts">
export interface TournamentsSelections {
  tournamentId: string
  name: string
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '~@npm/@gd/common-styles/lib/color-vars';
@import '../styles/vars';

.tournaments-selection {
  justify-content: space-around;
  display: flex;
  height: 100%;
  max-width: 100%;
}
.t-item {
  cursor: pointer;
  position: relative;
  margin-bottom: -1px;
  letter-spacing: 0.04em;
  padding: 1em 1.5em;
  text-align: center;
  font-weight: 700;
  color: @c0-e;
  transition: color 150ms;
  min-height: 3.5em;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  &:first-child {
  }
  &:hover {
    color: @c0-j;
    &:after {
      width: 100%;
    }
  }
  &:active {
    box-shadow: inset 0px 0px 0.5em @c0-d;
    background-color: @c0-a;
    &:after {
      height: 0.1em;
    }
  }
  &.active {
    color: @c0-j;
    &:after {
      width: 100%;
      height: 0.3em;
    }
  }
  &:after {
    transition: all 0.1s;
    content: ' ';
    position: absolute;
    width: 0;
    height: 1px;
    left: 50%;
    transform: translate(-50%, 0);
    bottom: 0;
    background: @c9-h;
    z-index: 1;
  }
}
.colorScheme.red & {
  .t-item {
    &:after {
      background: @colorScheme--red;
    }
  }
}

.colorScheme.midGreen & {
  .t-item {
    &:after {
      background: @colorScheme--midGreen;
    }
  }
}
</style>
